import SvgIcon from './svg-icon.vue'

export default SvgIcon
